import {createAnchor} from "./create/create-ahchor";
import {createButton} from "./create/create-button";
import {createList} from "./create/create-list";
import {createListItem} from "./create/create-list-item";

export const renderBreadcrumbs = (shopInfoData, pageName, onSpecButtonClickHandler = () => {}) => {
  const breadcrumbsElement = document.querySelector(`.breadcrumbs`);

  if (!breadcrumbsElement) {
    return;
  }

  if (!breadcrumbsData) {
    return;
  }

  const brearcrumbsListElement = createList(`breadcrumbs__list`);
  breadcrumbsElement.append(brearcrumbsListElement);

  Object.keys(breadcrumbsData)
  .forEach((key) => {
    const breadcrumb = breadcrumbsData[key];

    const liItemElement = createListItem(`breadcrumbs__item`);
    const anchorElement = createAnchor(`breadcrumbs__link`, breadcrumb.title || ``, breadcrumb.link || ``);

    liItemElement.append(anchorElement);
    brearcrumbsListElement.append(liItemElement);
  });

  if (pageName.includes(`group`) && shopInfoData.allow_spec) {
  // if (pageName.includes(`group`) && shopInfoData.show_spec) {
    const liItemElement = createListItem(`breadcrumbs__item`);
    const buttonElement = createButton(`Спецзаказ`, `breadcrumbs__button`);
    liItemElement.append(buttonElement);
    brearcrumbsListElement.append(liItemElement);

    if (!shopInfoData.show_spec) {
      buttonElement.addEventListener(`click`, onSpecButtonClickHandler);
    }

  }
};

